import { normalizeMinor } from './money';
export const formatCurrencyMinor = (amountMinor, currency, locale) => new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    useGrouping: 'always'
}).format(normalizeMinor(amountMinor) / 100);
